export { SocketIO } from './vue-socket.io';
export { Validation } from './vuelidate';
export { OnIdle, OnActive } from './idle-vue';
//# sourceMappingURL=vue-plugin-helper-decorator.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-plugin-helper-decorator/dist/vue-plugin-helper-decorator.js
// module id = null
// module chunks = 